export const LEGACY_PERMISSION_MAP = {
  "Publish Tenders & Receive Offers Only": [
    "create_tender",
    "publish_tender",
    "cancel_tender",
    "extend_tender_duration",
    "edit_tender_general_info",
    "edit_boq",
    "view_my_submitted_competitions",
    "view_published_tenders",
    "receive_financial_offers",
    "receive_technical_offers",
    "view_all_incoming_offers",
    "create_negotiation_offer_draft",
    "view_pending_supplier_negotiations",
    "award_supplier",
    "tenders_pending_awarding",
    "view_award_approvals",
    "review_financial_claim",
    "review_certificate_completion",
    "approve_claim_amount",
    "approve_claim_payment_processing",
    "approve_claim_payment",
    "create_contract_draft",
    "approve_reject_contract",
    "view_issued_contracts",
    "view_contract_approval_requests",
  ],
  "Submit Offers Only": [
    "create_offers_draft",
    "submit_offers",
    "view_all_submissions",
    "view_my_submissions",
    "accept_reject_invitations",
    "move_public_tender_to_my_submissions",
    "request_to_join_tender",
    "view_incoming_negotiations_for_review",
    "view_tenders_awarded_to_me",
    "accept_negotiation",
    "create_financial_claim",
    "view_financial_claims",
    "bank_account_management",
    "review_incoming_contract",
    "view_approved_contracts",
    "approve_reject_incoming_contracts",
  ],
  "Publish Tenders & Submit Offers": [
    "create_tender",
    "publish_tender",
    "cancel_tender",
    "extend_tender_duration",
    "edit_tender_general_info",
    "edit_boq",
    "view_my_submitted_competitions",
    "view_published_tenders",
    "receive_financial_offers",
    "receive_technical_offers",
    "view_all_incoming_offers",
    "create_negotiation_offer_draft",
    "view_pending_supplier_negotiations",
    "award_supplier",
    "tenders_pending_awarding",
    "view_award_approvals",
    "create_offers_draft",
    "submit_offers",
    "view_all_submissions",
    "view_my_submissions",
    "accept_reject_invitations",
    "move_public_tender_to_my_submissions",
    "request_to_join_tender",
    "view_incoming_negotiations_for_review",
    "view_tenders_awarded_to_me",
    "accept_negotiation",
    "review_financial_claim",
    "review_certificate_completion",
    "approve_claim_amount",
    "approve_claim_payment_processing",
    "approve_claim_payment",
    "create_financial_claim",
    "view_financial_claims",
    "bank_account_management",
    "create_contract_draft",
    "approve_reject_contract",
    "view_issued_contracts",
    "view_contract_approval_requests",
    "review_incoming_contract",
    "view_approved_contracts",
    "approve_reject_incoming_contracts",
  ],
};

export const LEGACY_PERMISSION_KEY_MAP = {
  approve_pending_tenders: "publish_tender",
  send_negotiation_offer: "create_negotiation_offer_draft",
  submit_contract_for_approval: "create_contract_draft",
};

export const PERMISSION_MODULE_MAP = {
  create_tender: "tenders_offers_management",
  publish_tender: "tenders_offers_management",
  cancel_tender: "tenders_offers_management",
  extend_tender_duration: "tenders_offers_management",
  edit_tender_general_info: "tenders_offers_management",
  edit_boq: "tenders_offers_management",
  view_my_submitted_competitions: "tenders_offers_management",
  view_published_tenders: "tenders_offers_management",
  receive_financial_offers: "tenders_offers_management",
  receive_technical_offers: "tenders_offers_management",
  view_all_incoming_offers: "tenders_offers_management",

  create_offers_draft: "offers_management",
  submit_offers: "offers_management",
  view_all_submissions: "offers_management",
  view_my_submissions: "offers_management",
  accept_reject_invitations: "offers_management",
  move_public_tender_to_my_submissions: "offers_management",
  request_to_join_tender: "offers_management",

  create_negotiation_offer_draft: "negotiation_award_management",
  view_pending_supplier_negotiations: "negotiation_award_management",
  award_supplier: "negotiation_award_management",
  tenders_pending_awarding: "negotiation_award_management",
  view_award_approvals: "negotiation_award_management",
  view_incoming_negotiations_for_review: "negotiation_award_management",
  view_tenders_awarded_to_me: "negotiation_award_management",
  accept_negotiation: "negotiation_award_management",

  review_financial_claim: "financial_claims_management",
  review_certificate_completion: "financial_claims_management",
  approve_claim_amount: "financial_claims_management",
  approve_claim_payment_processing: "financial_claims_management",
  approve_claim_payment: "financial_claims_management",
  create_financial_claim: "financial_claims_management",
  view_financial_claims: "financial_claims_management",
  bank_account_management: "financial_claims_management",

  create_contract_draft: "contracts_management",
  approve_reject_contract: "contracts_management",
  view_issued_contracts: "contracts_management|financial_claims_management",
  view_contract_approval_requests: "contracts_management|financial_claims_management",
  review_incoming_contract: "contracts_management|financial_claims_management",
  view_approved_contracts: "contracts_management|financial_claims_management",
  approve_reject_incoming_contracts: "contracts_management",
};

export const PERMISSION_GROUPS = [
  {
    key: "tender_management_issuing",
    labelKey: "authorized_permissions_tender_management_issuing",
    items: [
      { key: "create_tender", labelKey: "authorized_perm_create_tender", tooltipKey: "authorized_perm_create_tender_tooltip" },
      { key: "publish_tender", labelKey: "authorized_perm_publish_tender", tooltipKey: "authorized_perm_publish_tender_tooltip" },
      { key: "cancel_tender", labelKey: "authorized_perm_cancel_tender", tooltipKey: "authorized_perm_cancel_tender_tooltip" },
      { key: "extend_tender_duration", labelKey: "authorized_perm_extend_tender_duration", tooltipKey: "authorized_perm_extend_tender_duration_tooltip" },
      { key: "edit_tender_general_info", labelKey: "authorized_perm_edit_tender_general_info", tooltipKey: "authorized_perm_edit_tender_general_info_tooltip" },
      { key: "edit_boq", labelKey: "authorized_perm_edit_boq", tooltipKey: "authorized_perm_edit_boq_tooltip" },
      { key: "view_my_submitted_competitions", labelKey: "authorized_perm_view_my_submitted_competitions", tooltipKey: "authorized_perm_view_my_submitted_competitions_tooltip" },
      { key: "view_published_tenders", labelKey: "authorized_perm_view_published_tenders", tooltipKey: "authorized_perm_view_published_tenders_tooltip" },
      { key: "receive_financial_offers", labelKey: "authorized_perm_receive_financial_offers", tooltipKey: "authorized_perm_receive_financial_offers_tooltip" },
      { key: "receive_technical_offers", labelKey: "authorized_perm_receive_technical_offers", tooltipKey: "authorized_perm_receive_technical_offers_tooltip" },
      { key: "view_all_incoming_offers", labelKey: "authorized_perm_view_all_incoming_offers", tooltipKey: "authorized_perm_view_all_incoming_offers_tooltip" },
    ],
  },
  {
    key: "offers_management_supplier",
    labelKey: "authorized_permissions_offers_management_supplier",
    items: [
      { key: "create_offers_draft", labelKey: "authorized_perm_create_offers_draft", tooltipKey: "authorized_perm_create_offers_draft_tooltip" },
      { key: "submit_offers", labelKey: "authorized_perm_submit_offers", tooltipKey: "authorized_perm_submit_offers_tooltip" },
      { key: "view_all_submissions", labelKey: "authorized_perm_view_all_submissions", tooltipKey: "authorized_perm_view_all_submissions_tooltip" },
      { key: "view_my_submissions", labelKey: "authorized_perm_view_my_submissions", tooltipKey: "authorized_perm_view_my_submissions_tooltip" },
      { key: "accept_reject_invitations", labelKey: "authorized_perm_accept_reject_invitations", tooltipKey: "authorized_perm_accept_reject_invitations_tooltip" },
      { key: "move_public_tender_to_my_submissions", labelKey: "authorized_perm_move_public_tender_to_my_submissions", tooltipKey: "authorized_perm_move_public_tender_to_my_submissions_tooltip" },
      { key: "request_to_join_tender", labelKey: "authorized_perm_request_to_join_tender", tooltipKey: "authorized_perm_request_to_join_tender_tooltip" },
    ],
  },
  {
    key: "negotiation_issuing",
    labelKey: "authorized_permissions_negotiation_issuing",
    items: [
      { key: "create_negotiation_offer_draft", labelKey: "authorized_perm_create_negotiation_offer_draft", tooltipKey: "authorized_perm_create_negotiation_offer_draft_tooltip" },
      { key: "view_pending_supplier_negotiations", labelKey: "authorized_perm_view_pending_supplier_negotiations", tooltipKey: "authorized_perm_view_pending_supplier_negotiations_tooltip" },
      { key: "award_supplier", labelKey: "authorized_perm_award_supplier", tooltipKey: "authorized_perm_award_supplier_tooltip" },
      { key: "tenders_pending_awarding", labelKey: "authorized_perm_tenders_pending_awarding", tooltipKey: "authorized_perm_tenders_pending_awarding_tooltip" },
      { key: "view_award_approvals", labelKey: "authorized_perm_view_award_approvals", tooltipKey: "authorized_perm_view_award_approvals_tooltip" },
    ],
  },
  {
    key: "negotiation_supplier",
    labelKey: "authorized_permissions_negotiation_supplier",
    items: [
      { key: "accept_negotiation", labelKey: "authorized_perm_accept_negotiation", tooltipKey: "authorized_perm_accept_negotiation_tooltip" },
      { key: "view_incoming_negotiations_for_review", labelKey: "authorized_perm_view_incoming_negotiations_for_review", tooltipKey: "authorized_perm_view_incoming_negotiations_for_review_tooltip" },
      { key: "view_tenders_awarded_to_me", labelKey: "authorized_perm_view_tenders_awarded_to_me", tooltipKey: "authorized_perm_view_tenders_awarded_to_me_tooltip" },
    ],
  },
  {
    key: "financial_claims_issuing",
    labelKey: "authorized_permissions_financial_claims_issuing",
    items: [
      { key: "review_financial_claim", labelKey: "authorized_perm_review_financial_claim", tooltipKey: "authorized_perm_review_financial_claim_tooltip" },
      { key: "review_certificate_completion", labelKey: "authorized_perm_review_certificate_completion", tooltipKey: "authorized_perm_review_certificate_completion_tooltip" },
      { key: "approve_claim_amount", labelKey: "authorized_perm_approve_claim_amount", tooltipKey: "authorized_perm_approve_claim_amount_tooltip" },
      { key: "approve_claim_payment_processing", labelKey: "authorized_perm_approve_claim_payment_processing", tooltipKey: "authorized_perm_approve_claim_payment_processing_tooltip" },
      { key: "approve_claim_payment", labelKey: "authorized_perm_approve_claim_payment", tooltipKey: "authorized_perm_approve_claim_payment_tooltip" },
    ],
  },
  {
    key: "financial_claims_supplier",
    labelKey: "authorized_permissions_financial_claims_supplier",
    items: [
      { key: "create_financial_claim", labelKey: "authorized_perm_create_financial_claim", tooltipKey: "authorized_perm_create_financial_claim_tooltip" },
      { key: "view_financial_claims", labelKey: "authorized_perm_view_financial_claims", tooltipKey: "authorized_perm_view_financial_claims_tooltip" },
      { key: "bank_account_management", labelKey: "authorized_perm_bank_account_management", tooltipKey: "authorized_perm_bank_account_management_tooltip" },
    ],
  },
  {
    key: "contracts_issuing",
    labelKey: "authorized_permissions_contracts_issuing",
    items: [
      { key: "create_contract_draft", labelKey: "authorized_perm_create_contract_draft", tooltipKey: "authorized_perm_create_contract_draft_tooltip" },
      { key: "approve_reject_contract", labelKey: "authorized_perm_approve_reject_contract", tooltipKey: "authorized_perm_approve_reject_contract_tooltip" },
      { key: "view_issued_contracts", labelKey: "authorized_perm_view_issued_contracts", tooltipKey: "authorized_perm_view_issued_contracts_tooltip" },
      { key: "view_contract_approval_requests", labelKey: "authorized_perm_view_contract_approval_requests", tooltipKey: "authorized_perm_view_contract_approval_requests_tooltip" },
    ],
  },
  {
    key: "contracts_supplier",
    labelKey: "authorized_permissions_contracts_supplier",
    items: [
      { key: "review_incoming_contract", labelKey: "authorized_perm_review_incoming_contract", tooltipKey: "authorized_perm_review_incoming_contract_tooltip" },
      { key: "view_approved_contracts", labelKey: "authorized_perm_view_approved_contracts", tooltipKey: "authorized_perm_view_approved_contracts_tooltip" },
      { key: "approve_reject_incoming_contracts", labelKey: "authorized_perm_approve_reject_incoming_contracts", tooltipKey: "authorized_perm_approve_reject_incoming_contracts_tooltip" },
    ],
  },
];

export const PERMISSION_CATEGORY_MAP = PERMISSION_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.key] = group.labelKey;
  });
  return acc;
}, {});

export const CATEGORY_ORDER = PERMISSION_GROUPS.map((group) => group.labelKey);

export const normalizePermissionList = (value) => {
  const normalizeKeys = (items) =>
    items
      .map((item) => LEGACY_PERMISSION_KEY_MAP[item] || item)
      .filter(Boolean);

  if (Array.isArray(value)) {
    return normalizeKeys(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return normalizeKeys(parsed);
      }
    } catch (_) {
      // ignore json parse errors
    }
    return normalizeKeys(LEGACY_PERMISSION_MAP[trimmed] || [trimmed]);
  }

  return [];
};
